import { useEffect, useContext, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Button } from '@mui/material';
import { getReportParams } from '../../api/reporting';

import { ReportingContext } from './ReportingContainer';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import dayjs from 'dayjs';

export const ReportParams = () => {
  const [params, setParams] = useState([]);
  const { reportId, reportName, setEndpoint, setEndpointParams, navToReportingPage } = useContext(ReportingContext);

  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);

  const generateReport = async () => {
    let queryParams = {};
    if (params.find((v) => v.data === 'Created' && v.Type === 'Date')) {
      if (!startDate) queryParams['startDate'] = undefined;
      else queryParams['startDate'] = dayjs(startDate).format('YYYY-MM-DD HH:mm:ss');
      if (!endDate) {
        queryParams['endDate'] = undefined;
      } else {
        queryParams['endDate'] = dayjs(endDate)
          .set('hour', 23)
          .set('minute', 59)
          .set('second', 59)
          .format('YYYY-MM-DD HH:mm:ss');
      }
    }
    setEndpointParams(queryParams);
    navToReportingPage(2);
  };

  useEffect(() => {
    const fetch = async () => {
      const params = await getReportParams(reportId);
      setEndpoint(params[0].endPoint);

      const reportParams = JSON.parse(params[0].parameters);

      setParams(reportParams);

      // if report doesn't require any parameters, navigate directly to report display page
      if (reportParams.length === 0) {
        navToReportingPage(2);
      }
    };
    fetch();
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid className="two-column-divs right-container" sx={{ padding: 3 }}>
        <Box
          sx={{
            mb: 4,
            mt: 2,
            fontSize: '24px',
            fontWeight: '100',
            fontFamily: 'Roboto, sans-serif',
          }}
        >
          <span>{reportName}</span>
        </Box>
        {params.find((v) => v.data === 'Created' && v.Type === 'Date') && (
          <>
            <Box
              sx={{
                mb: 2,
                fontSize: '15px',
                fontWeight: '100',
                fontFamily: 'Roboto, sans-serif',
              }}
            >
              Enter Date Range
            </Box>
            <Box sx={{ display: 'flex', direction: 'row', gap: 2 }}>
              <DatePicker id={'startDate'} onChange={(e) => setStartDate(e)} value={startDate} format="DD/MM/YYYY" />
              <DatePicker id={'endDate'} onChange={(e) => setEndDate(e)} value={endDate} format="DD/MM/YYYY" />
              <Button variant="contained" onClick={generateReport}>
                Generate report
              </Button>
            </Box>
          </>
        )}

        <Button
          sx={{ width: '80px', mt: 2 }}
          variant="text"
          startIcon={<ArrowBackIosIcon />}
          onClick={() => navToReportingPage(null)}
        >
          Back
        </Button>
      </Grid>
    </LocalizationProvider>
  );
};
